<template>
    <div class="gift-ani">
        <img :src="avatar" class="avatar"/>
        <div class="info-name">
            <div class="nick">{{nick}}</div>
            <div class="gift">送出 火箭X1</div>
        </div>
        <img src="../../../../assets/image/live/gift-item.png" class="gitf-item"/>
    </div>
</template>

<script>
export default {
  props: {
    nick: {},
    avatar: {}
  },
  data () {
      return {}
  },
  methods: {
    showgift () {
      this.$emit('showGift')
    }
  },
  computed: {},
  created () {
    setTimeout(() => {
      this.$emit('hideani')
    }, 1000)
  }
}
</script>
<style type="scss" scoped>
    .gift-ani {
        background-image: linear-gradient(
                270deg,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.18) 100%
        );
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        width: 6.9609375rem;
        height: 1.6875rem;
        position: relative;
    }
    .avatar,.info-name{
        display: inline-block;
        vertical-align: middle
    }
    .avatar{
        height: 1.51875rem;
        width: 1.51875rem;
        border-radius: 0.759375rem;
        margin: 0.084375rem;
    }
    .nick{
        font-family: PingFangSC-Medium;
        font-size: 0.6rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: left;
        line-height: 0.50625rem;
    }
    .gift{
        font-family: PingFangSC-Regular;
        font-size: 0.6rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: left;
        line-height: 0.928125rem;
    }
    .gitf-item{
        height: 3.5859375rem;
        width: 1.96171875rem;
        position: absolute;
        left: 4.8515625rem;
        top: 0;
        margin-top: -0.84375rem
    }
</style>
